import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import {
  takeUntil,
  delay,
  debounceTime,
  distinctUntilChanged,
  tap,
  map,
  switchMap,
  catchError,
} from 'rxjs/operators';
import { SharedValidators, AppFilter, ConfirmModal } from 'src/modules/shared';
import { environment } from 'src/environments/environment';
import { DepartmentService, OrganizationService } from '../../services';
interface IDepartmentUserModalContext {
  title: string;
  data?: any;
}
function check(data: Array<any>, deviceArr) {
  for (let i = 0; i < data.length; i++) {
    var node = data[i];
    deviceArr.filter((eq) => eq.appUserId == node['appUserId'])[0]
      ? data.splice(i, 1)
      : '';
  }
  return data;
}

@Component({
  selector: 'app-select-user-modal',
  templateUrl: './select-user-modal.component.html',
  styleUrls: ['./select-user-modal.component.scss'],
})
export class DepartmentUserModalComponent implements OnInit, OnDestroy {
  search: FormControl = new FormControl('');
  searchable: boolean = true;
  lots;
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  newUserForm: FormGroup;
  existingUserForm: FormGroup;
  roles: Array<any>;
  departmentUsers: Array<any>;
  users: Array<any>;
  department;
  emailError;
  emailServerError;
  public emailLoading = false;
  collapseNew: boolean = true;
  collapseExisting: boolean = true;
  rolesLookup;
  public userLookup = async (query: string, initial: number) => {
    return new Promise<any[]>((resolve) => {
      let filter = new AppFilter({ rows: 10000 });
      let searchFilter = {
        groupOp: 'OR',
        rules: [
          {
            field: 'appUserEmail',
            op: 'cn',
            data: '',
          },
          {
            field: 'username',
            op: 'cn',
            data: '',
          },
          {
            field: 'firstName',
            op: 'cn',
            data: '',
          },
          {
            field: 'lastName',
            op: 'cn',
            data: '',
          },
        ],
      };
      if (query) {
        searchFilter.rules[0].data = query;
        searchFilter.rules[1].data = query;
        searchFilter.rules[2].data = query;
      }
      filter.filters = JSON.stringify(searchFilter);
      this.departmentSvc
        .getUnAssignDepartmentUsers({
          organizationId: this.department.organizationId,
          params: filter,
        })
        .subscribe(
          (res: any) => {
            resolve(res['rows']);
          },
          (error) => {
            resolve([]);
          }
        );
    });
  };
  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    private userService: OrganizationService,
    private departmentSvc: DepartmentService,
    private modalService: SuiModalService,
    public modal: SuiModal<IDepartmentUserModalContext, void, void>
  ) {
    this.roles = modal.context.data.roles;
    // this.users = modal.context.data.users;
    this.department = modal.context.data.department;
    this.newUserForm = fb.group({
      userRole: ['', Validators.required],
      appUserEmail: ['', [Validators.required, SharedValidators.email]],
    });
    this.existingUserForm = fb.group({
      userRole: ['', Validators.required],
      appUserId: ['', [Validators.required]],
    });
    // this.getUsersDepartment();
    this.getUsers();

    this.newUserForm
      .get('appUserEmail')
      .valueChanges.pipe(
        tap((res) => {
          this.emailLoading = true;
          this.emailError = false;
          this.emailServerError = false;
        }),
        delay(800),
        debounceTime(800),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        this.http
          .get(`${environment.API_SERVER}/auth/email-availablity/${value}/`)
          .subscribe(
            (res) => {
              this.emailLoading = false;
              if (res['status'] === true) {
                this.emailError = false;
              } else {
                this.emailError = true;
              }
            },
            (error) => {
              this.emailLoading = false;
              if (error['status'] !== 404) {
                this.emailServerError = false;
              } else {
                this.emailServerError = true;
              }
            }
          );
      });
  }
  isFieldValid(field: string) {
    return (
      (!this.newUserForm.get(field).valid &&
        this.newUserForm.get(field).touched) ||
      (this.newUserForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  isFieldValidE(field: string) {
    return (
      (!this.existingUserForm.get(field).valid &&
        this.existingUserForm.get(field).touched) ||
      (this.existingUserForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCssE(field: string) {
    return {
      error: this.isFieldValidE(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  getUsersDepartment() {}
  getUsers() {
    let filter = new AppFilter({ rows: 10000 });
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'appUserEmail',
          op: 'cn',
          data: '',
        },
        {
          field: 'username',
          op: 'cn',
          data: '',
        },
        {
          field: 'firstName',
          op: 'cn',
          data: '',
        },
        {
          field: 'lastName',
          op: 'cn',
          data: '',
        },
      ],
    };
    filter.filters = JSON.stringify(searchFilter);
    this.pending = true;
    this.userService
      .getUsers({
        organizationId: this.department.organizationId,
        params: filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.departmentUsers = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }
  submit() {
    if (this.newUserForm.valid && !this.emailError) {
      this.pending = true;
      this.departmentSvc
        .inviteNewUser({
          organizationId: this.department.organizationId,
          body: this.newUserForm.value,
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.newUserForm.reset();
            this.collapseNew = !this.collapseNew;
            this.success = 'User invited to department successfully';
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
          }
        );
    }
  }

  onDelete(event) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove User?',
          'Are you sure you want to remove user?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.delete(event);
      })
      .onDeny(() => {});
  }

  delete(user) {
    this.pending = true;
    this.userService
      .removeUser({
        organizationId: this.department.organizationId,
        appUserEmail: user.appUserId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'User removed from department successfully';
          this.getUsers();
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }

  submitExisting() {
    if (this.existingUserForm.valid) {
      this.pending = true;
      this.departmentSvc
        .inviteExistingUser({
          organizationId: this.department.organizationId,
          body: this.existingUserForm.value,
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.existingUserForm.reset();
            this.collapseExisting = !this.collapseExisting;
            this.success = 'User invited to department successfully';
            // this.userLookup('', 1);
            this.getUsers();
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
          }
        );
    }
  }
  save() {
    this.modal.approve(null);
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class DepartmentUserModal extends ComponentModalConfig<
  IDepartmentUserModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(DepartmentUserModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
